import AllChannels from '@/views/pages/acquisition/all_channels.vue'
import SocialNetworks from '@/views/pages/acquisition/social_networks.vue'
import Campaigns from '@/views/pages/acquisition/campaigns.vue'
import Websites from '@/views/pages/acquisition/websites.vue'
import SearchEngines from '@/views/pages/acquisition/search_engines.vue'

export default [
  {
    path: '/acquisition-all-channels',
    name: 'acquisition-all-channels',
    component: AllChannels
  },
  {
    path: '/acquisition-social-networks',
    name: 'acquisition-social-networks',
    component: SocialNetworks
  },
  {
    path: '/acquisition-campaigns',
    name: 'acquisition-campaigns',
    component: Campaigns
  },
  {
    path: '/acquisition-websites',
    name: 'acquisition-websites',
    component: Websites
  },
  {
    path: '/acquisition-search-engines',
    name: 'acquisition-search-engines',
    component: SearchEngines
  }
]
